var isRuntimeInsideNodeServer = function isRuntimeInsideNodeServer() {
  return typeof window === "undefined";
};
var isTouchDevice = function isTouchDevice() {
  if (!isRuntimeInsideNodeServer()) {
    var _window, _navigator;
    return !!((_window = window) !== null && _window !== void 0 && _window.ontouchstart) || ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.maxTouchPoints) > 0;
  }
  return false;
};

export { isRuntimeInsideNodeServer, isTouchDevice };
//# sourceMappingURL=deviceHelpers.js.map
